import 'brace';
import 'brace/mode/text';
import 'brace/mode/javascript';
import 'brace/mode/html';
import 'brace/mode/json';
import 'brace/mode/xml';
import 'brace/mode/groovy';
import 'brace/mode/sh';
import 'brace/mode/sql';
import 'brace/theme/eclipse';

import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  AfterViewInit, ViewChild
} from '@angular/core';

import { AceComponent, AceConfigInterface } from 'ngx-ace-wrapper';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {DialogService} from "../../services/dialog.service";


@Component({
  selector: 'micro-ace-editor',
  templateUrl: './micro-ace-editor.component.html',
  // encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: MicroAceEditorComponent
    }
  ]
})

export class MicroAceEditorComponent implements OnInit, OnChanges, AfterViewInit  {
  @Input() mode:string = 'text';
  @Input() theme:string = 'eclipse';
  @Input() style: string = 'height:200px; width:100%';
  @Input() class: string = "mono";
  @Input() readOnly: boolean;
  @Input() disabled: boolean;
  @Input() required: boolean;
  @Input() canFullscreen: boolean = false;
  @Input() inFullscreen: boolean = false;

  @Output()
  textChange:EventEmitter<any> = new EventEmitter<any>();
  @Input()
  text:any;

  fullscreen: boolean;

  @Input() config: AceConfigInterface;

  @ViewChild(AceComponent, { static: false }) componentRef?: AceComponent;

  onChange = (val) => {};
  onTouched = () => {};
  touched = false;

  constructor(private dialogService:DialogService) {
  }

  ngOnInit() {
    if (!this.config) {
      this.config = {
          mode: this.mode,
          theme: this.theme,
          readOnly : this.readOnly,
      };
    }
  }

  change(e) {
    this.onChange(e);
    this.textChange.emit(e);
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(val: string): void {
    this.text = val;
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'text') {
        // nothing to do, no reload, etc.
      }
    }
  }


  public getEditor() {
    return this.componentRef.directiveRef.ace();
  }

  onEditorBlur($event: any) {
  }

  onEditorFocus($event: any) {
  }

  onValueChange($event: string) {
    this.change($event);
  }

  toggleFullscreen(): void {
    this.fullscreen = !this.fullscreen;
    this.openInDialog();
  }

  getEditorClasses(): any {
    return {
      'micro-ace-editor-container': true,
      'fullscreen': this.fullscreen,
      ...(this.classListFromInput || {})
    };
  }

  getEditorStyles(): { [key: string]: string } {
    if (!this.style) return {};

    var cs = this.parseStyleString(this.style);
    if (this.inFullscreen) {
      cs["width"] = "100%";
      cs["height"] = "100%";
    }
    return cs;
  }

  private parseStyleString(style: string): { [key: string]: string } {
    return (style || '')
      .split(';')
      .map(s => s.trim())
      .filter(s => s)
      .reduce((acc, curr) => {
        const [key, value] = curr.split(':').map(s => s.trim());
        if (key && value) acc[key] = value;
        return acc;
      }, {} as { [key: string]: string });
  }

  get classListFromInput(): { [key: string]: boolean } {
    if (typeof this.class === 'string') {
      return this.class
        .split(' ')
        .reduce((acc, cls) => (cls ? { ...acc, [cls]: true } : acc), {});
    }
    return this.class || {};
  }

  openInDialog() {
    let context = {
      config: this.config,
      mode: this.mode,
      theme: this.theme,
      style: this.style,
      class: this.class,
      readOnly: this.readOnly,
      disabled: this.disabled,
      required: this.required,
      text: this.text,
      dialogStyle: "width: 80vw; height: 80vh;"
    }
    this.dialogService.openEditor(context)
      .subscribe(updatedText => {
        this.fullscreen = false;
        this.text = updatedText ? updatedText : context.text;
      })
  }

}
